import { render, staticRenderFns } from "./work_bench_two.vue?vue&type=template&id=a158a1c2&scoped=true&"
import script from "./work_bench_two.vue?vue&type=script&lang=js&"
export * from "./work_bench_two.vue?vue&type=script&lang=js&"
import style0 from "./work_bench_two.vue?vue&type=style&index=0&id=a158a1c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a158a1c2",
  null
  
)

export default component.exports